<template>
  <div class="hll-code-box">
    <img class="img-default" src="https://coupe-static.huolala.cn/image/90b98e1ee47ebe2fac37667303b172fe32e3d003.png" alt="">
    <img v-if="portType === 'hlluser'" @click="openWXMiniprogram" class="img-default" src="~@/assets/img/hll-xcx-code-2.png">
    <img v-else class="img-default" src="~@/assets/img/hll-xcx-code.png" alt="">
  </div>
</template>
<script>
import { recordClick } from "@/utils/recordMTA";
import { callApp } from "@/utils/callApp";
export default {
  props: ['templateName', 'currentRef', 'portType'],
  methods: {
    openWXMiniprogram() {
      recordClick("打开小程序", this.templateName);  
      let path = `page/tabBar/homepage/index?ref=${this.currentRef}`
      callApp({
        "action":"openWXMiniprogram",
        "to":"wechat1, wechatn",
        "title":"货拉拉购车",
        "content":"货拉拉购车",
        "icon_url":"https://charter.huolala.cn/h5/cdn/img/miniprogram/share-img.png",
        "link_url":"",
        "appName":"gh_3d4bd50ac5ae",
        "path": path,
        "miniprogram_webpage_url":"",
        "miniprogram_type":""
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hll-code-box{
  font-size: 0;
  .img-default{
    width: 100%;
  }
}
</style>